


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// @ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import uniq from "lodash/uniq";

import { STORE_KEY, store } from "./_store";
import moment from "moment";
import ExcelJS from "exceljs";
import Combobox from "@/components/Controls/Combobox.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",
      "full_reloading",

      "items",
      "weeks",
      "targetUpdate",
      "splitFactPrevMonths",
      "prevFactWeekColumns",
      "reportTablePage",
      "reportTablePerPage",
      "reportTotalCount"
    ]),
    ...mapGetters(STORE_KEY, ["total"]),
    ...mapGetters("ubic", ["isAdmin", "isController"])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      "setReportOptions",
      "exportDataAsXLSX",
      "toggleAddress",
      "togglePoint"
    ])
  },
  components: {
    TitleBar,
    Combobox
  }
})
export default class ShipmentForecast extends Vue {
  onReportTablePageChange(page: number | string) {
    const p = typeof page === "number" ? page : parseInt(String(page), 10);
    if (!Number.isFinite(p) || p < 1) {
      return;
    }
    this.$store.dispatch(`${STORE_KEY}/setReportTablePage`, p);
  }

  get titleStack() {
    return ["Прогноз отгрузок"];
  }

  localFilter: any = {
    targetDates: moment()
      .startOf("month")
      .toDate(),
    employee_id: [],
    client_name: null,
    product_types: [],
    delivery_zone_group_id: null,
    only_custom_plan: null,
    split_fact_prev_months: "0",
    with_archived: "0"
  };
  opened: any[] = [];
  columnsList: any[] = [
    { id: "category_income", label: "Категория" },
    { id: "client_name", label: "Клиент" },
    { id: "manager_name", label: "Менеджер" },
    { id: "secondary_manager_name", label: "Со-менеджер" },
    { id: "fact_d3", label: "факт -3 месяца" },
    { id: "fact_d2", label: "факт -2 месяца" },
    { id: "fact_d1", label: "факт -1 месяца" },
    { id: "fact_avg", label: "среднее" },
    { id: "fact_py", label: "факт -1 год" },
    { id: "plan", label: "план ПР" },
    { id: "plan_manual", label: "план Ц" },
    { id: "fact", label: "факт" },
    { id: "delta", label: "дельта" },
    { id: "percent", label: "процент" },
    { id: "week_plan", label: "Неделя: план ПР" },
    { id: "week_plan_manual", label: "Неделя: план Ц" },
    { id: "week_fact", label: "Неделя: факт" }
  ];
  categories: any[] = [
    { id: "A", label: "A" },
    { id: "B", label: "B" },
    { id: "C", label: "C" }
  ];
  /** Клиент / Клиент-ТК / Дистрибьютор — резолв по code, fallback на 4|8. */
  saleClientTypeIds: string[] = ["d:client_types:4", "d:client_types:8"];
  showColumns: any[] = [];
  get clientTypeRelFilters() {
    return [{ $in: ["type_id", this.saleClientTypeIds] }];
  }
  get defaultSort() {
    return [
      this.$route.query.sortField || "client_name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  weekTotal(week: any) {
    const tw = this.total && this.total.weeks;
    const w =
      tw && week && week.key != null ? tw[week.key] : null;
    return w || { plan: 0, plan_manual: 0, coef: 0, fact: 0 };
  }

  weekHeaderBlock(week: any) {
    const p = this.weekHeaderParts(week);
    return {
      weekNum: week && week.week_num,
      lineMain: p.lineMain,
      lineSub: p.lineSub
    };
  }

  /**
   * Подпись колонки недели: для первой/последней недели месяца — дни, попадающие в выбранный месяц;
   * серая строка — полные границы ISO-недели. Без ошибочного endOf('week') на week_end.
   */
  weekHeaderParts(week: any) {
    if (
      !week ||
      week.week_start == null ||
      week.week_end == null ||
      week.week_start === "" ||
      week.week_end === ""
    ) {
      return { lineMain: "—", lineSub: null as string | null };
    }
    const w0 = moment(week.week_start).startOf("day");
    const w1 = moment(week.week_end).startOf("day");
    if (!w0.isValid() || !w1.isValid()) {
      return { lineMain: "—", lineSub: null as string | null };
    }
    const full = `${w0.format("DD.MM.YYYY")} – ${w1.format("DD.MM.YYYY")}`;
    if (!this.localFilter.targetDates) {
      return { lineMain: full, lineSub: null as string | null };
    }
    const m0 = moment(this.localFilter.targetDates).startOf("month");
    const m1 = moment(this.localFilter.targetDates).endOf("month");
    const i0 = moment.max(w0, m0);
    const i1 = moment.min(w1, m1);
    if (i0.isAfter(i1)) {
      return { lineMain: full, lineSub: null };
    }
    const clipped = !w0.isSame(i0, "day") || !w1.isSame(i1, "day");
    const monthTag = moment(this.localFilter.targetDates).format("MM.YYYY");
    if (clipped) {
      return {
        lineMain: `${i0.format("DD.MM")}–${i1.format("DD.MM")} (${monthTag})`,
        lineSub: `календ. нед. ${w0.format("DD.MM")}–${w1.format("DD.MM")}`
      };
    }
    return { lineMain: full, lineSub: null };
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.client_id]);
    } else {
      this.opened = uniq(
        this.opened.filter($row => $row.client_id != row.client_id)
      );
    }
  }
  setPlanValue(
    row_id: number,
    address_id: number,
    product_id: number,
    point_id: number | null,
    week_key: any,
    value: any
  ) {
    this.$store.dispatch(`${STORE_KEY}/setPlanValue`, {
      row_id,
      address_id,
      product_id,
      point_id,
      week_key,
      value
    });
  }
  setMonthPlanValue(
    row_id: number,
    address_id: number,
    product_id: number,
    point_id: number | null,
    value: any
  ) {
    this.$store.dispatch(`${STORE_KEY}/setMonthPlanValue`, {
      row_id,
      address_id,
      product_id,
      point_id,
      value
    });
  }
  recalcMonthPlan(
    row_id: number,
    address_id: number,
    product_id: number,
    point_id: number | null
  ) {
    this.$store.dispatch(`${STORE_KEY}/recalcMonthPlan`, {
      row_id,
      address_id,
      product_id,
      point_id
    });
  }
  recalcWeekPlan(
    row_id: number,
    address_id: number,
    product_id: number,
    point_id: number | null,
    week_key: any
  ) {
    this.$store.dispatch(`${STORE_KEY}/recalcWeekPlan`, {
      row_id,
      address_id,
      product_id,
      point_id,
      week_key
    });
  }
  savePlans() {
    this.$store.dispatch(`${STORE_KEY}/savePlans`).then(() => {
      this.$store.dispatch(`${STORE_KEY}/reloadData`, this.$route.query);
    });
  }
  fixPlans() {
    this.$store.dispatch(`${STORE_KEY}/fixPlans`).then(() => {
      this.$store.dispatch(`${STORE_KEY}/reloadData`, this.$route.query);
    });
  }
  tableToExcel(no_products: boolean = false) {
    this.$store
      .dispatch(`${STORE_KEY}/exportData`, {
        ...this.localFilter,
        no_products,
        showColumns: this.showColumns
      })
      .then((csvContent: any[]) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Отчет");
        csvContent.forEach((row: any, idx: number) => {
          const _row: any = worksheet.addRow(row);

          _row.eachCell({ includeEmpty: true }, function(
            cell: any,
            colNumber: number
          ) {
            console.log("Cell ", cell);
            if (colNumber > 1) {
              cell.numFmt = "0.00";
            }
            if (idx == 0) {
              cell.style.font = {
                family: 2,
                size: 11,
                bold: true
              };
              // cell.fill = {
              //   type: 'pattern',
              //   pattern:'darkVertical',
              //   fgColor:{argb:'FF72BF44'}
              // };
            }
            if (idx == 1) {
              cell.style.font = {
                family: 2,
                size: 11,
                bold: true
              };
            }
            if (idx == 2) {
              cell.style.font = {
                bold: true
              };
            }
          });
        });
        workbook.xlsx
          .writeBuffer()
          .then(function(xls64: any) {
            const a = document.createElement("a");
            const data = new Blob([xls64], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = "export.xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          })
          .catch(function(error: any) {
            console.log(error.message);
          });
      });
  }
  setColumns(value: any[]) {
    // @ts-ignore
    this.$storage.set({
      key: "shipment_forecast_columns",
      value: JSON.stringify(value)
    });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.resolveSaleClientTypeIds();
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates // @ts-ignore
        ? moment(this.$route.query.targetDates).toDate() // @ts-ignore
        : moment()
            .startOf("month")
            .toDate();
    // @ts-ignore
    this.localFilter.employee_id =
      this.$route.query && this.$route.query.employee_id
        ? this.$route.query.employee_id
        : [];
    this.localFilter.employee_id = Array.isArray(this.localFilter.employee_id)
      ? this.localFilter.employee_id
      : [this.localFilter.employee_id];
    // @ts-ignore
    this.localFilter.client_name = this.$route.query.client_name;
    // @ts-ignore
    this.localFilter.client_id = this.$route.query.client_id;
    // @ts-ignore
    this.localFilter.delivery_zone_group_id = this.$route.query.delivery_zone_group_id;
    // @ts-ignore
    this.localFilter.product_types =
      this.$route.query && this.$route.query.product_types
        ? this.$route.query.product_types
        : [];
    this.localFilter.product_types = Array.isArray(
      this.localFilter.product_types
    )
      ? this.localFilter.product_types
      : [this.localFilter.product_types];
    // @ts-ignore
    this.localFilter.with_archived =
      this.$route.query && this.$route.query.with_archived === "1"
        ? "1"
        : "0";
    // @ts-ignore
    this.localFilter.only_custom_plan = this.$route.query.only_custom_plan;
    // @ts-ignore
    this.localFilter.split_fact_prev_months =
      this.$route.query.only_custom_plan === "1" &&
      this.$route.query.split_fact_prev_months === "1"
        ? "1"
        : "0";
    // @ts-ignore
    this.localFilter.category_income = this.$route.query.category_income;

    this.handleParamsChange();
    // @ts-ignore
    this.$storage
      .get({ key: "shipment_forecast_columns" })
      .then((data: any) => {
        let columns = data.value ? JSON.parse(data.value) : [];
        if (!Array.isArray(columns)) {
          columns = [columns];
        }
        this.showColumns =
          columns.length > 0
            ? columns
            : this.columnsList.map((col: any) => {
                return col.id;
              });
      });
  }

  resolveSaleClientTypeIds() {
    (this as any)
      .$db([
        (this as any)
          .$q("RESOLVE_SALE_CLIENT_TYPES")
          .raw("documents.list")
          .action({
            columns: {
              id: "ct.id",
              code: "ct.code"
            },
            from: "s:client_types",
            from_as: "ct",
            where: {
              $in: [
                "ct.code",
                { $: ["client", "client-opt", "distributor"] }
              ]
            },
            page_size: 10
          })
      ])
      .then((result: any) => {
        const docs =
          result.getOperation("RESOLVE_SALE_CLIENT_TYPES").getContent()
            .documents || [];
        const ids = docs.map((d: any) => d.id).filter(Boolean);
        if (ids.length) {
          this.saleClientTypeIds = ids;
        }
      })
      .catch(() => {
        /* keep fallback 4|8 */
      });
  }

  setFilterData() {
    this.$store.dispatch(`${STORE_KEY}/clear`);
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] =
        key == "targetDates"
          ? moment(this.localFilter[key]).format("YYYY-MM-DD")
          : this.localFilter[key];
      return ac;
    }, {});

    if (query.only_custom_plan !== "1") {
      delete query.split_fact_prev_months;
    }
    if (query.with_archived !== "1") {
      delete query.with_archived;
    }

    this.$store.commit(`${STORE_KEY}/SET_REPORT_TABLE_PAGE`, 1);
    this.$router.replace({
      query
    });
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.commit(`${STORE_KEY}/SET_REPORT_TABLE_PAGE`, 1);
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
